import React from 'react';
// import { motion } from 'framer-motion';
// import SafeIcon from '../common/SafeIcon';
// import * as FiIcons from 'react-icons/fi';

// const { FiExternalLink, FiGithub } = FiIcons;

const ProjectsPage = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  const fadeInUp = { hidden: { opacity: 0, y: 30 }, visible: { opacity: 1, y: 0 } };

  const projects = [
    {
      title: "AI-Powered Course Platform",
      description: "A comprehensive e-learning platform built with AI-driven features for personalized learning.",
      tags: ["React", "Node.js", "AI", "Supabase"],
      liveUrl: "#",
      githubUrl: "#"
    },
    {
      title: "Real-time Chat Application",
      description: "A chat application with real-time messaging, user authentication, and presence indicators.",
      tags: ["React", "Firebase", "WebSockets"],
      liveUrl: "#",
      githubUrl: "#"
    },
    {
      title: "E-commerce Store with AI Recommendations",
      description: "An online store featuring AI-powered product recommendations and a seamless checkout process.",
      tags: ["React", "Stripe", "AI", "Firebase"],
      liveUrl: "#",
      githubUrl: "#"
    }
  ];

  return (
    <div className="min-h-screen bg-white pt-16">
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{ visible: { transition: { staggerChildren: 0.2 } } }}
            className="text-center"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-4xl md:text-6xl font-bold mb-8 leading-tight font-serif"
            >
              Our Projects
            </motion.h1>
            <motion.p
              variants={fadeInUp}
              className="text-xl text-black-200 mb-10 leading-relaxed max-w-3xl mx-auto"
            >
              Explore some of the real-world projects we've built.
            </motion.p>
          </motion.div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-xl shadow-lg border border-black-200 overflow-hidden flex flex-col"
              >
                <div className="p-6 flex-grow">
                  <h3 className="text-2xl font-bold text-black-900 mb-4">{project.title}</h3>
                  <p className="text-black-700 mb-4">{project.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {project.tags.map((tag, i) => (
                      <span key={i} className="bg-black-100 text-black-800 px-3 py-1 rounded-full text-sm font-medium">{tag}</span>
                    ))}
                  </div>
                </div>
                <div className="p-6 bg-black-50 flex justify-between">
                  <a href={project.liveUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-black-800 hover:text-blue-600 transition-colors">
                    <SafeIcon icon={FiExternalLink} className="w-5 h-5" />
                    <span>Live Demo</span>
                  </a>
                  <a href={project.githubUrl} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-black-800 hover:text-blue-600 transition-colors">
                    <SafeIcon icon={FiGithub} className="w-5 h-5" />
                    <span>GitHub</span>
                  </a>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
  */
};

export default ProjectsPage;